module.exports = __webpack_public_path__ + "fonts/Bebas-Regular.6f6f82d.ttf";


//////////////////
// WEBPACK FOOTER
// ./src/assets/Bebas-Regular.ttf
// module id = Sino
// module chunks = 4